/**
 * "Demo" pill shown next to records that belong to a super-admin-flagged demo account
 * (PBI #1347). Transactional admin views keep showing demo records; this marks them as
 * simulated so nobody mistakes a demo order for a real charge or shipment.
 */

import { Badge } from '@mantine/core';
import { brandColors } from '../../config/theme';

interface DemoAccountPillProps {
  /** Mantine badge size. Defaults to the compact table size. */
  size?: 'xs' | 'sm';
}

export const DemoAccountPill = ({ size = 'xs' }: DemoAccountPillProps) => (
  <Badge
    color={brandColors.demo}
    size={size}
    variant="filled"
    title="Demo account: orders are simulated and email is suppressed"
    data-testid="demo-account-pill"
  >
    Demo
  </Badge>
);
